import { default as domainCatalogGrid } from './grid/routes'
import { default as domainCatalogJoin } from './juncao/routes'
import { default as domainCatalogGridGen } from './gerar-ofertas/routes'

export default [
    ...domainCatalogGrid,
    ...domainCatalogJoin,
    ...domainCatalogGridGen
]
